<template>
    <header class="header">
        <div class="container">
            <div class="logo">
                <a href="/" class="logo">
                    <img :src="companyInfo.logoUrl || 'https://0406-lhf.oss-cn-chengdu.aliyuncs.com/logo.jpg'" alt="公司logo">
                    <h2>四川庚源电力科技有限公司</h2>
                </a>
            </div>

            <nav class="nav" v-if="!isMobile">
                <ul>
                    <li :class="{ active: $route.path === '/' }"><a href="/">首页</a></li>
                    <li :class="{ active: $route.path === '/about' }"><a href="/about">关于我们</a></li>
                    <li :class="{ active: $route.path === '/services' }"><a href="/services">业务范围</a></li>
                    <li :class="{ active: $route.path === '/cases' }"><a href="/cases">成功案例</a></li>
                    <li :class="{ active: $route.path === '/partners' }"><a href="/partners">合作伙伴</a></li>
                    <li :class="{ active: $route.path === '/contact' }"><a href="/contact">联系我们</a></li>
                </ul>
            </nav>

            <div class="mobile-menu-btn" @click="toggleMobileMenu" v-else>
                <i class="fa fa-bars"></i>
            </div>
        </div>

        <!-- 移动端菜单 -->
        <div class="mobile-menu" v-if="showMobileMenu">
            <ul>
                <li :class="{ active: $route.path === '/' }"><a href="/" @click="toggleMobileMenu">首页</a></li>
                <li :class="{ active: $route.path === '/about' }"><a href="/about" @click="toggleMobileMenu">关于我们</a></li>
                <li :class="{ active: $route.path === '/services' }"><a href="/services" @click="toggleMobileMenu">业务范围</a></li>
                <li :class="{ active: $route.path === '/cases' }"><a href="/cases" @click="toggleMobileMenu">成功案例</a></li>
                <li :class="{ active: $route.path === '/partners' }"><a href="/partners" @click="toggleMobileMenu">合作伙伴</a></li>
                <li :class="{ active: $route.path === '/contact' }"><a href="/contact" @click="toggleMobileMenu">联系我们</a></li>
            </ul>
        </div>
    </header>
</template>

<script>
import { companyApi } from '@/api'

export default {
    name: 'HeaderComponent',
    data() {
        return {
            companyInfo: {},
            isMobile: false,
            showMobileMenu: false
        }
    },
    mounted() {
        this.getCompanyInfo()
        this.checkScreenSize()
        window.addEventListener('resize', this.checkScreenSize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkScreenSize)
    },
    methods: {
        getCompanyInfo() {
            companyApi.getCompanyInfo().then(res => {
                if (res) {
                    this.companyInfo = res
                }
            }).catch(err => {
                console.error('获取公司信息失败:', err)
            })
        },
        checkScreenSize() {
            this.isMobile = window.innerWidth < 768
            this.showMobileMenu = false
        },
        toggleMobileMenu() {
            this.showMobileMenu = !this.showMobileMenu
        }
    }
}
</script>

<style scoped>
.company-name {
    display: flex;
    font-size: 18px;
    margin: 0; /* 清除默认margin */
}
.header {
    background-color: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    position: sticky;
    top: 0;
    z-index: 100;
}

.container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
}

.logo {
    display:flex;
    align-items: center;

}

.logo img {
    height: 50px;
    margin-right: 10px;

}

.logo span {
    font-size: 1.2rem;
    font-weight: bold;
    color: #2c3e50;

}

.nav ul {
    display: flex;
}

.nav li {
    margin-left: 30px;
}

.nav a {
    color: #2c3e50;
    font-size: 1rem;
    font-weight: 500;
    transition: color 0.3s;
}

.nav a:hover,
.nav .active a {
    color: #165DFF;
}

.mobile-menu-btn {
    font-size: 1.5rem;
    color: #2c3e50;
    cursor: pointer;
}

.mobile-menu {
    position: fixed;
    top: 80px;
    left: 0;
    width: 100%;
    background-color: #fff;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
    z-index: 99;
}

.mobile-menu ul {
    padding: 20px 0;
}

.mobile-menu li {
    text-align: center;
    margin-bottom: 15px;
}

.mobile-menu a {
    color: #2c3e50;
    font-size: 1.1rem;
    display: block;
    padding: 10px 0;
}

.mobile-menu .active a {
    color: #165DFF;
    font-weight: bold;
}

@media (max-width: 768px) {
    .logo span {
        font-size: 1rem;
    }

    .nav {
        display: none;
    }
}

@media (min-width: 769px) {
    .mobile-menu-btn,
    .mobile-menu {
        display: none;
    }
}
</style>